export default function Logo({ size = 40, showText = true, textBelow = false, light = false }) {
  const textColor = light ? '#ffffff' : '#1A1E1A';
  const subColor  = light ? 'rgba(255,255,255,0.6)' : '#85BB65';
  const markH     = size;
  const markW     = Math.round(size * 0.72);
  const wordSize  = size * 0.52;
  const subSize   = size * 0.17;

  // Clean geometric K — flat, no background shape
  const mark = (
    <svg width={markW} height={markH} viewBox="0 0 18 24" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', flexShrink: 0 }}>
      {/* Vertical bar */}
      <rect x="0" y="0" width="5" height="24" rx="1" fill="#85BB65" />
      {/* Upper arm */}
      <polygon points="5,13 5,9.5 18,0 18,4.5" fill="#85BB65" />
      {/* Lower arm */}
      <polygon points="5,11 5,14.5 18,24 18,19.5" fill="#85BB65" />
    </svg>
  );

  const wordmark = showText && (
    <div>
      <div style={{
        fontFamily: "'Raleway', sans-serif",
        fontWeight: 800,
        fontSize: wordSize,
        color: textColor,
        letterSpacing: '-0.02em',
        lineHeight: 1,
      }}>
        Korunto
      </div>
      {!textBelow && (
        <div style={{
          fontFamily: "'Raleway', sans-serif",
          fontWeight: 700,
          fontSize: subSize,
          color: subColor,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          marginTop: 2,
        }}>
          Loyalty Platform
        </div>
      )}
    </div>
  );

  if (textBelow) {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: size * 0.14 }}>
        {mark}
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: wordSize, color: textColor, letterSpacing: '-0.02em', lineHeight: 1 }}>Korunto</div>
          <div style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: subSize, color: subColor, letterSpacing: '0.18em', textTransform: 'uppercase', marginTop: 2 }}>Loyalty Platform</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.22 }}>
      {mark}
      {wordmark}
    </div>
  );
}
